<template>
  <div>
    <FormItem :label="label">
      <div class="input-holder">
        <b-form-input v-model="search" placeholder="Enter the company name" />

        <ul v-if="search" class="results">
          <li @click="addNew">
            <div class="logo-image"></div>
            <span>+ (new) {{ search }}</span>
          </li>

          <li
            v-for="company in results"
            :key="company.key"
            @click="add(company)"
          >
            <div
              class="logo-image"
              :style="{ backgroundImage: 'url(' + company.logoImageUrl + ')' }"
            ></div>
            <span>{{ company.name }}</span>
          </li>
        </ul>
      </div>
    </FormItem>
  </div>
</template>

<script>
import FormItem from '@/components/form/FormItem'
import CompanyModel from '@/models/Company'
import debounce from 'lodash/debounce'

export default {
  components: {
    FormItem
  },
  props: {
    label: { type: String, default: 'Search and add companies' }
  },
  data: () => ({
    search: '',
    results: []
  }),
  watch: {
    search: 'load'
  },
  methods: {
    load: debounce(async function() {
      if (!this.search) {
        return
      }

      const { data } = await this.$axios.get('companies', {
        params: {
          search: this.search,
          crossplatform: true
        }
      })

      this.results = data.docs.map((item) => new CompanyModel(item))
    }, 200),
    addNew() {
      this.$emit('addNew', this.search)

      this.search = ''
    },
    add(company) {
      this.search = ''

      this.$emit('add', {
        company
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.input-holder {
  position: relative;
}

.results {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 300px;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  padding: 0;
  margin: 5px 0 0 0;

  > li {
    display: flex;
    align-items: center;
    transition: background-color 0.3s;
    cursor: pointer;

    .logo-image {
      width: 50px;
      height: 50px;
      background: #fff no-repeat center center / cover;
      margin-right: 15px;
      border: 2px solid #fff;
    }

    span {
      color: $gray-700;
      transition: color 0.3s;
    }

    &:hover {
      background-color: $blue-900;

      span {
        color: $white;
      }
    }
  }
}
</style>
